import React, { useEffect } from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import {TextField,Divider,Button, Container, Grid, Typography} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

import WrapTextIcon from '@material-ui/icons/WrapText';
import OpacityIcon from '@material-ui/icons/Opacity';
import Swal from 'sweetalert2'
import {withRouter} from 'react-router-dom'
import {Tooltip} from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import Equipamentos from '../Equipamentos/Equipamentos';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import DisplayCompletoToner from '../Suprimentos/DisplayCompletoToner'



const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
});

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ModalSuprimentos = (props) => {
  
    const [open, setOpen] = React.useState(false)
   

  

  return (
    <div>
      <Tooltip title='Lançar novo pedido de Toner'>
        <OpacityIcon style={{cursor:'pointer', fontSize: 30, color:'#444'}} onClick={() => { setOpen(true) }} />
      </Tooltip>
      <Dialog
        hideBackdrop
        disableBackdropClick disableEscapeKeyDown
        fullWidth
        maxWidth='md'
        onClose={() => setOpen(false)} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={() => setOpen(false)}>
          {props.titulo}
        </DialogTitle>
        <DialogContent dividers >

          <Grid container spacing={1}>

            <Grid item xs={2}>
              <TextField
                value={props.equipamento.codigoadicional ? props.equipamento.codigoadicional : ''}
                size={'small'}
                label='Placa'
                variant='outlined'
                fullWidth
                InputLabelProps={{ shrink: true }}


              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                size={'small'}
                value={props.equipamento.numeroserie ? props.equipamento.numeroserie : ''}
                label='Número de série'
                variant='outlined'
                fullWidth
                InputLabelProps={{ shrink: true }}

              />
            </Grid>



            <Grid item xs={6}>
              <TextField
                value={props.equipamento.setor ? props.equipamento.setor : ''}
                size={'small'}
                label='Setor'
                variant='outlined'
                fullWidth
                InputLabelProps={{ shrink: true }}


              />
            </Grid>
          </Grid>
          <br />
          <br />

          <Grid container spacing={1}>

            <Grid item xs={4}>
              <TextField

                size={'small'}
                label='Solicitante'
                variant='outlined'
                fullWidth
                InputLabelProps={{ shrink: true }}


              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                size={'small'}
                label='E-mail'
                variant='outlined'
                fullWidth
                InputLabelProps={{ shrink: true }}

              />
            </Grid>
          </Grid>

          <Grid container spacing={1} style={{ marginTop: "10px" }}>
            <Grid item xs={3}>
              <FormLabel component="legend">Status do Equipamento</FormLabel>
              <RadioGroup defaultValue="Equipamento Normal" aria-label="gender" name="customized-radios"  >
                <FormControlLabel value="Equipamento Normal" control={<StyledRadio />} label="Equipamento Normal" />
                <FormControlLabel value="Pouco Toner" control={<StyledRadio />} label="Pouco Toner" />
                <FormControlLabel value="Sem Toner" control={<StyledRadio />} label="Sem Toner" />
              </RadioGroup>
            </Grid>
            <Grid item xs={3}>
              <FormLabel component="legend">Finalidade Pedido</FormLabel>
              <RadioGroup defaultValue="Toner Reserva" aria-label="gender" name="customized-radios"  >
                <FormControlLabel value="Toner Reserva" control={<StyledRadio />} label="Toner Reserva" />
                <FormControlLabel value="Defeito Toner" control={<StyledRadio />} label="Defeito Toner" />
              </RadioGroup>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label='Observações Gerais'
                variant='outlined'
                InputLabelProps={{ shrink: true }}
                fullWidth
                size='small'
                // inputRef={refObservacoes}
                multiline
                rows={6}
                rowsMax={6}

              />
            </Grid>

          </Grid>
          <br />



          <Grid container spacing={1}>
            <Grid item xs={2}>
              <DisplayCompletoToner color="#00f" rotulo='Ciano' percentual={props.equipamento.detalhesColeta.ciano} width={'44px'} height={'44px'} marginTop={'-14px'} />

            </Grid>
            <Grid item xs={2}>
              <DisplayCompletoToner color='#cf3476' rotulo='Magenta' percentual={props.equipamento.detalhesColeta.magenta} width={'44px'} height={'44px'} marginTop={'-14px'} />

            </Grid>
            <Grid item xs={2}>
              <DisplayCompletoToner color="#ffd600" rotulo='Amarelo' percentual={props.equipamento.detalhesColeta.amarelo} width={'44px'} height={'44px'} marginTop={'-14px'} />

            </Grid>
            <Grid item xs={2}>
              <DisplayCompletoToner color="#000" rotulo='Black' percentual={props.equipamento.detalhesColeta.preto} width={'44px'} height={'44px'} marginTop={'-14px'} />

            </Grid>
            <Grid item xs={2}>
              <TextField
                label='Monocromático'
                variant='outlined'
                defaultValue={props.equipamento.detalhesColeta.contadormono}
                InputLabelProps={{ shrink: true }}
                fullWidth
                className='textNumberLarge1'
                inputProps={{
                  "min": 0,
                  "max": 99999999
                }}
                pattern="^-?[0-9]\d*\.?\d*$"
                InputProps={{ min: 0 }}
                type='number'

              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                label='Colorido'
                pattern="^-?[0-9]\d*\.?\d*$"
                variant='outlined'
                defaultValue={props.equipamento.detalhesColeta.contadorcolor}
                InputLabelProps={{ shrink: true }}
                fullWidth
                className='textNumberLarge1'                
                InputProps={{ min: 0 }}
                type='number'

              />
            </Grid>

          </Grid>


        </DialogContent>
        <DialogActions>
          <Grid item xs={3} spacing={3} className='container-buttons'>
            <Button color='primary' variant='contained' ><SaveIcon />  Gravar</Button>
            <Button color='secondary' variant='contained' autoFocus onClick={() => setOpen(false)} ><ClearIcon /> Cancelar</Button>
          </Grid>

        </DialogActions>
      </Dialog>
    </div>
  );
}


export default withRouter(ModalSuprimentos)